var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 22,
    viewBox: "0 0 5 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.35714C5 3.65848 3.88021 4.71429 2.5 4.71429C1.11979 4.71429 0 3.65848 0 2.35714C0 1.0558 1.11979 0 2.5 0C3.88021 0 5 1.0558 5 2.35714ZM0 11C0 9.69866 1.11979 8.64286 2.5 8.64286C3.88021 8.64286 5 9.69866 5 11C5 12.3013 3.88021 13.3571 2.5 13.3571C1.11979 13.3571 0 12.3013 0 11ZM5 19.6429C5 20.9442 3.88021 22 2.5 22C1.11979 22 0 20.9442 0 19.6429C0 18.3415 1.11979 17.2857 2.5 17.2857C3.88021 17.2857 5 18.3415 5 19.6429Z",
    fill: "#388188"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.12f68c37ff4e6b68e50944f798ee8b8b.svg";
export { ForwardRef as ReactComponent };